import * as angular from 'angular';
import CategoriesBridge from './bridges/CategoriesBridge';
import CategoryAddEditModalBridge from './components/Modals/CategoryAddEditModalBridge';

angular
  .module('flowingly.runner.setup')
  .component('subCategories', CategoriesBridge)
  .component('categoryAddEditModal', CategoryAddEditModalBridge);
